import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PhotoshopPicker } from 'react-color';
import Popover from 'material-ui/Popover';
import RaisedButton from 'material-ui/RaisedButton';
import ImageUploadSection from './ImageUploadSection';
import { FormSection, Spinner, WatchClickOutside, WhiteLabelPreview } from 'components';
import * as styles from './WhiteLabelForm.scss';
var WhiteLabelForm = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    uploadingFile: state.whiteLabel.uploadingFile
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(WhiteLabelForm, _Component);

  var _super = _createSuper(WhiteLabelForm);

  function WhiteLabelForm(props) {
    var _this;

    _classCallCheck(this, WhiteLabelForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      var _this$setState;

      var _this$props$initialVa = _this.props.initialValues,
          primaryColor = _this$props$initialVa.primaryColor,
          secondaryColor = _this$props$initialVa.secondaryColor,
          logoUrl = _this$props$initialVa.logoUrl,
          domain = _this$props$initialVa.domain;

      _this.setState((_this$setState = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        logoUrl: logoUrl,
        domain: domain,
        uploadingFile: false,
        displayPrimaryColorPicker: false
      }, _defineProperty(_this$setState, "displayPrimaryColorPicker", false), _defineProperty(_this$setState, "popoverAnchor", null), _this$setState));
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemovePopover", function () {
      _this.setState({
        displayPrimaryColorPicker: false,
        displaySecondaryColorPicker: false,
        popoverAnchor: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSwatchClick", function (swatch, currentTarget) {
      if (swatch === 'Primary') {
        _this.setState({
          displayPrimaryColorPicker: !_this.state.displayPrimaryColorPicker,
          popoverAnchor: currentTarget
        });
      } else {
        _this.setState({
          displaySecondaryColorPicker: !_this.state.displaySecondaryColorPicker,
          popoverAnchor: currentTarget
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderImageArea", function () {
      var img = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.logoWrap,
        style: {
          backgroundImage: "url(".concat(_this.state.logoUrl, ")"),
          marginBottom: 16
        }
      }), /*#__PURE__*/React.createElement(ImageUploadSection, {
        height: 50,
        removeImage: function removeImage() {
          _this.setState({
            logoUrl: _this.props.initialValues.logoUrl
          });
        },
        onChange: function onChange(_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              imageUrl = _ref2[0];

          _this.setState({
            logoUrl: imageUrl
          });
        }
      }));
      return /*#__PURE__*/React.createElement(FormSection, {
        title: "Logo",
        style: {
          position: 'relative'
        }
      }, _this.state.uploadingFile ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : img);
    });

    _this.state = {
      previousPrimaryColor: null,
      previousSecondaryColor: null,
      displayPrimaryColorPicker: false,
      displaySecondaryColorPicker: false,
      primaryColor: props.initialValues.primaryColor,
      secondaryColor: props.initialValues.secondaryColor,
      logoUrl: props.initialValues.logoUrl,
      domain: props.initialValues.domain,
      uploadingFile: false
    };
    return _this;
  }

  _createClass(WhiteLabelForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6 ".concat(styles.colXS6),
        style: {
          borderRight: '1px solid #f1f1f1'
        }
      }, this.renderImageArea(), /*#__PURE__*/React.createElement(FormSection, {
        title: "Colors"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colorSection
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.colorLabel
      }, "Primary: "), /*#__PURE__*/React.createElement("span", {
        className: styles.colorSwatch,
        style: {
          backgroundColor: this.state.primaryColor
        },
        onClick: function onClick(event) {
          _this2.setState({
            displayPrimaryColorPicker: true,
            popoverAnchor: event.currentTarget
          });
        }
      }), /*#__PURE__*/React.createElement(Popover, {
        anchorEl: this.state.popoverAnchor,
        open: this.state.displayPrimaryColorPicker,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {// this.setState({ displayPrimaryColorPicker: false });
        }
      }, /*#__PURE__*/React.createElement(PhotoshopPicker, {
        header: "Primary Color Picker",
        color: this.state.primaryColor,
        onChange: function onChange(color) {
          _this2.setState({
            previousPrimaryColor: !_this2.state.previousPrimaryColor ? _this2.state.primaryColor : _this2.state.previousPrimaryColor,
            primaryColor: color.hex
          });
        },
        onAccept: function onAccept() {
          _this2.setState({
            displayPrimaryColorPicker: false,
            previousPrimaryColor: null
          });
        },
        onCancel: function onCancel() {
          _this2.setState({
            displayPrimaryColorPicker: false,
            primaryColor: _this2.state.previousPrimaryColor ? _this2.state.previousPrimaryColor : _this2.state.primaryColor,
            previousPrimaryColor: null
          });
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.colorSection
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.colorLabel
      }, "Secondary: "), /*#__PURE__*/React.createElement("span", {
        className: styles.colorSwatch,
        style: {
          backgroundColor: this.state.secondaryColor
        },
        onClick: function onClick(event) {
          _this2.setState({
            displaySecondaryColorPicker: true,
            popoverAnchor: event.currentTarget
          });
        }
      }), /*#__PURE__*/React.createElement(Popover, {
        anchorEl: this.state.popoverAnchor,
        open: this.state.displaySecondaryColorPicker,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {//                    this.setState({ displaySecondaryColorPicker: false });
        }
      }, /*#__PURE__*/React.createElement(PhotoshopPicker, {
        header: "Secondary Color Picker",
        color: this.state.secondaryColor,
        onChange: function onChange(color) {
          _this2.setState({
            previousSecondaryColor: !_this2.state.previousSecondaryColor ? _this2.state.secondaryColor : _this2.state.previousSecondaryColor,
            secondaryColor: color.hex
          });
        },
        onAccept: function onAccept() {
          _this2.setState({
            displaySecondaryColorPicker: false,
            previousSecondaryColor: null
          });
        },
        onCancel: function onCancel() {
          _this2.setState({
            displaySecondaryColorPicker: false,
            secondaryColor: _this2.state.previousSecondaryColor ? _this2.state.previousSecondaryColor : _this2.state.secondaryColor,
            previousSecondaryColor: null
          });
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: styles.buttonWrap
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: this.props.saving,
        label: "Save",
        onClick: function onClick() {
          _this2.props.onSubmit({
            primaryColor: _this2.state.primaryColor,
            secondaryColor: _this2.state.secondaryColor,
            logoUrl: _this2.state.logoUrl
          });
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginLeft: 24
        },
        disabled: this.props.saving,
        label: "Cancel",
        onClick: this.handleReset
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6 ".concat(styles.colXS6)
      }, /*#__PURE__*/React.createElement(WhiteLabelPreview, {
        settings: {
          primaryColor: this.state.primaryColor,
          secondaryColor: this.state.secondaryColor,
          domain: this.props.initialValues.domain,
          logoUrl: this.state.logoUrl
        }
      }))));
    }
  }]);

  return WhiteLabelForm;
}(Component)) || _class);
export { WhiteLabelForm as default };